import { createFileRoute, Outlet } from '@tanstack/react-router';
import CleaningMissionsPage from '../../features/environmental-cleaning/pages/CleaningMissionsPage';
import { getOpenCleaningMissionsQueryOptions } from '../../features/environmental-cleaning/queries';

export const Route = createFileRoute('/_auth/environmental-cleaning/missions')({
  component: RouteComponent,
  loader: async ({ context }) => {
    const { healthCenter } = context.authenticationContext;
    if (!healthCenter) {
      return;
    }
    await context.queryClient.ensureQueryData(getOpenCleaningMissionsQueryOptions(healthCenter));
  },
});

function RouteComponent() {
  const { healthCenter } = Route.useRouteContext().authenticationContext;
  if (!healthCenter) {
    return null;
  }
  return (
    <>
      <CleaningMissionsPage healthCenter={healthCenter} />
      <Outlet />
    </>
  );
}
